import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusWifi = (props) => {
    const width = props.width ? props.width + 'px' : '38px';
    const height = props.height ? props.height + 'px' : '37px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 38 37"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <g clipPath="url(#clip0_3559_3189)">
                <path d="M38 33.1221H0V37.0061H38V33.1221Z" fill="#1D1D1B" />
                <path
                    d="M6.0847 9.11664C9.24449 5.87996 13.6187 3.87202 18.4468 3.87202C23.7465 3.87202 28.498 6.29354 31.699 10.0996C32.6835 9.2545 33.6562 8.41536 34.6053 7.60019C30.7087 2.95497 24.9137 0 18.4468 0C12.5693 0 7.24014 2.43949 3.39062 6.37745L6.0847 9.11664Z"
                    fill="#1D1D1B"
                />
                <path
                    d="M10.7546 14.6969C12.7177 12.677 15.4412 11.4243 18.4536 11.4243C21.7313 11.4243 24.673 12.9167 26.6596 15.2603C27.6029 14.4572 28.5815 13.618 29.5718 12.7669C26.8837 9.57816 22.8985 7.55225 18.4536 7.55225C14.3978 7.55225 10.7192 9.24251 8.06641 11.9637L10.7605 14.7029L10.7546 14.6969Z"
                    fill="#1D1D1B"
                />
                <path
                    d="M15.4636 20.1573C16.2182 19.3661 17.2793 18.8686 18.4465 18.8686C19.6727 18.8686 20.781 19.414 21.5415 20.2832C22.4022 19.5579 23.3867 18.7188 24.4596 17.8017C22.9976 16.0875 20.8459 14.9966 18.4465 14.9966C16.2241 14.9966 14.2138 15.9256 12.7695 17.4241L15.4636 20.1633V20.1573Z"
                    fill="#1D1D1B"
                />
            </g>
        </SvgStyled>
    );
};

export default CampusWifi;
